import React, { Fragment, useEffect, useState } from 'react'
import BannerServices from '../../../Api/Banner/BannerServices';
import { Box, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { baseUrl } from '../../../../axios';
import { DeleteForever, KeyboardArrowLeft } from '@mui/icons-material';
import { SuccessToaster } from '../../../Components/Toaster/Toaster';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog';
import Colors from '../../../Assets/Styles/Colors';
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';

function Banners() {
  const [bannerImages, setBannerImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const navigate = useNavigate();

  const getAllBanners = async () => {
    try {
      const result = await BannerServices.getAllBanners();
      // console.log(result);
      const filteredBanners = result?.data?.banners.filter((item) => item.type == "home");
      setBannerImages(filteredBanners);
    }
    catch (e) {
      console.log(e);
    }
  };

  const handleDelete = async () => {
    try {
      const result = await BannerServices.deleteBanner(id);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message);
      }
    } catch (err) {
      console.log(err)
    } finally {
      getAllBanners();
    }
  };

  useEffect(() => {
    getAllBanners();
  }, []);

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={handleDelete}
        title={"Delete Banner"}
        btn={"Delete"}
      />
      <Grid container rowGap={"20px"}>
        <Grid item md={12}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{
              background: Colors.primaryGradient,
              p: 2,
              borderRadius: "12px",
            }}
          >
            <Grid item xs={6}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <IconButton onClick={() => navigate(-1)}>
                  <KeyboardArrowLeft sx={{ color: Colors.white }} />
                </IconButton>
                <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                  Banners
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <BreadCrumbs currentPage={["Banners"]} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container spacing={3}>
            {bannerImages.map((item, i) => (
              <Grid key={i} item md={6}>
                <Box sx={{ position: "relative" }}>
                  <CardMedia
                    component={"img"}
                    src={baseUrl + item.imageUrl}
                    sx={{
                      width: "100%",
                      height: "295px",
                      objectFit: "cover"
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0
                    }}
                  >
                    <IconButton onClick={() => { setOpen(true); setId(item?._id) }}>
                      <DeleteForever sx={{ color: Colors.black }} />
                    </IconButton>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  )
}

export default Banners
